import React from 'react'
import reactStamp from 'react-stamp'
import Login from '../components/Login'
import UserService  from '../services/UserService'
import Links from '../router/links'
import Header from '../components/Header'


export default reactStamp(React).compose({

    init(){
        this.handleUserLogin = this.handleUserLogin.bind(this);
        this.handlePasswordTextField = this.handlePasswordTextField.bind(this);
        this.handleLoginTextField = this.handleLoginTextField.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.isUserLogged = this.isUserLogged.bind(this);
    },

    state: {
        login: "",
        password: "",
        err: false
    },

    render() {

        if (this.isUserLogged()) {
            Links.toPortal();
            return null;
        } else {
            return (
                <div>
                    <Header operations="register"/>
                    <Login
                        handleUserLogin={this.handleUserLogin}
                        handleLoginTextField={this.handleLoginTextField}
                        handlePasswordTextField={this.handlePasswordTextField}
                        err={this.state.err}
                    />
                </div>

            );
        }
    },

    handleUserLogin(e){
        e.preventDefault();
        UserService.auth(this.state.login, this.state.password, this.handleResponse);
    },

    handleResponse(id, name){
        if (id != "") {
            this.setState({err: false})
            sessionStorage.setItem('id', id);
            sessionStorage.setItem('email',"");
            Links.toPortal();
        } else {
            this.setState({err: true})
        }
    },

    handleLoginTextField(loginText){
        this.setState({login: loginText})
    },

    handlePasswordTextField(passwordText){
        this.setState({password: passwordText})
    },

    isUserLogged() {
        return (sessionStorage.getItem("id") != "" && sessionStorage.getItem("id") != undefined)
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/containers/Login.js
 **/